import "draft-js/dist/Draft.css";
import { useLayoutEffect } from "react";
import { QueryClientProvider } from "react-query";
import { Provider } from "react-redux";
import { Bounce, ToastContainer } from "react-toastify";
import { queryClient } from "./api";
import { Router } from "./components/routes/Router";
import "./i18n";
import { store } from "./store/store";

function App() {
  const readingDirection = localStorage.getItem("i18nextReadingDirection");

  useLayoutEffect(() => {
    document.documentElement.dir = readingDirection || "ltr";
    return () => {
      document.documentElement.dir = "ltr";
    };
  }, [readingDirection]);

  return (
    <>
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick={false}
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
            transition={Bounce}
          />
          <Router />
        </QueryClientProvider>
      </Provider>
    </>
  );
}

export default App;
